
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/directions/[id]",
      function () {
        return require("private-next-pages/directions/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/directions/[id]"])
      });
    }
  